const faqRender = () => {
  let collapsed = document.querySelectorAll(".collapsed");
    
    for(let i=0; i<collapsed.length; i++)
    {
    collapsed[i].addEventListener("click",
    	function(){
          let collapse = this.nextElementSibling;

          this.classList.contains('collapsed') ? 
            this.classList.replace('collapsed', 'faq-active'):
              this.classList.replace('faq-active', 'collapsed'); 

            if(collapse.classList.contains('collapse')){
              collapse.classList.replace('collapse', 'show'); 
              collapse.style.maxHeight = collapse.scrollHeight + 'px';
            }
            else{
              collapse.style.maxHeight = null;
              setTimeout(() => {
                         collapse.classList.replace('show', 'collapse');
                          },[350]);
              
            }    	
            });
      
     
    } 
}
   
document.addEventListener("shopify:section:load", faqRender);
window.addEventListener('load',  faqRender);